import React from 'react';
import EcoClub6Class2025 from '../views/EcoClub6Class2025/EcoClub6Class2025';

const DesktopAppPage = () => {
  return <EcoClub6Class2025 />;
};

export default DesktopAppPage;
